import { motion, useReducedMotion } from "framer-motion";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { LANDING_COPY, LANDING_SCENES, type LandingScene } from "@/data/landingContent";
import { SceneArt } from "./illustrations/SceneArt";
import { StatusDot } from "./StatusPills";

export const SceneGallery = () => {
  const reduce = useReducedMotion();

  return (
    <section id="situacoes" className="container mx-auto scroll-mt-24 px-5 pb-6 pt-20 md:px-8 md:pt-28">
      <motion.div
        initial={reduce ? false : { opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.5 }}
      >
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-500">
          {LANDING_COPY.scenesEyebrow}
        </p>
        <h2 className="mt-3 max-w-3xl text-3xl font-bold tracking-[-0.03em] md:text-4xl">
          {LANDING_COPY.scenesTitle}
        </h2>
        <p className="mt-3 max-w-2xl text-base text-neutral-500 md:text-lg">{LANDING_COPY.scenesSub}</p>
      </motion.div>

      <div className="mt-10 hidden grid-cols-3 gap-4 md:grid">
        {LANDING_SCENES.map((scene, index) => (
          <motion.div
            key={scene.id}
            initial={reduce ? false : { opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.4, delay: reduce ? 0 : index * 0.05 }}
          >
            <SceneCard scene={scene} />
          </motion.div>
        ))}
      </div>

      <div className="mt-8 md:hidden">
        <Carousel opts={{ align: "start", dragFree: true }} className="w-full">
          <CarouselContent className="-ml-3">
            {LANDING_SCENES.map((scene) => (
              <CarouselItem key={scene.id} className="basis-[78%] pl-3">
                <SceneCard scene={scene} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  );
};

const SceneCard = ({ scene }: { scene: LandingScene }) => (
  <article className="landing-card h-full overflow-hidden rounded-[20px] border border-neutral-200 bg-white">
    <SceneArt id={scene.id} className="h-40 w-full" />
    <div className="px-4 py-4">
      <p className="font-semibold text-neutral-900">{scene.name}</p>
      <p className="mt-1 text-sm text-neutral-500">{scene.line}</p>
      <StatusDot status={scene.status} className="mt-3 text-sm" />
    </div>
  </article>
);
